// using this should be slightly faster than e.g. character >= '0' && character <= '9'
export const isDigitCharCode = (charCode: number): boolean => {
  return charCode >= 48 && charCode <= 57
}
